import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'page-header-from-filter',
  templateUrl: './page-header-from-filter.component.html',
  styleUrls: ['./page-header-from-filter.component.scss']
})
export class PageHeaderFromFilterComponent implements OnInit {
  @Input() cardCategory: string;
  @Input() cardTitle: string;
  @Input() actionTitle: string;
  @Input() withAction: boolean = true;
  @Input() startDate: Date;
  @Output() filterEvent:EventEmitter<any> = new EventEmitter<any>();
  @Output() actionEvent:EventEmitter<any> = new EventEmitter<any>();


  constructor() { }

  ngOnInit() {
  }

  filter() {
    this.filterEvent.emit({startDate:this.startDate});
  }

  action() {
    this.actionEvent.emit();
  }

}
